import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import {
  Button,
  Col,
  Form,
  ListGroup,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import * as Yup from "yup";
import { Field, FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
// import swal from "sweetalert";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  capitalizeString,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  GET_MixDesignMasterTypes,
  POST_GetMixDesignMasterByID,
  POST_GetMixDesignMasterListByMixDesignMasterType,
  POST_MixDesignMasterDelete,
  POST_MixDesignMasterExport,
  POST_MixDesignMasterInsert,
  POST_MixDesignMasterStatusUpdate,
  POST_MixDesignMasterUpdate,
} from "../../../helpers/url_helper";
import { get, post } from "../../../helpers/api_helper";

const MixDesignMaster = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);

  const [mixDesignMasterTypeList, setMixDesignMasterTypeList] = useState([]);
  const [mixDesignMasterList, setMixDesignMasterList] = useState([]);

  const [mixDesignMasterType, setMixDesignMasterType] = useState(1);
  const [mixDesignMasterTypeName, setMixDesignMasterTypeName] =
    useState("Type of Cement");

  const [mixDesignMasterModal, setMixDesignMasterModal] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Search: "",
      Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: { Search, Status },
  } = formikFilter;

  const get_MixDesignMasterTypes = async () => {
    setIsLoading(true);
    await get(GET_MixDesignMasterTypes)
      .then((response) => {
        if (response?.IsSuccess) {
          setMixDesignMasterTypeList(response?.List);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    get_MixDesignMasterTypes();
  }, []);

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    formikFilter.resetForm();
    if (sortBy != "") {
      setSortBy("");
    } else {
      getData();
    }
  }, [mixDesignMasterType]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      MixDesignMasterType: mixDesignMasterType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser.BranchIDEncrypt,
    };

    await post(POST_GetMixDesignMasterListByMixDesignMasterType, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setMixDesignMasterList(response?.List);
        setIsLoading(false);

        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      MixDesignMasterType: mixDesignMasterType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser.BranchIDEncrypt,
    };
    post(POST_MixDesignMasterExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    MixDesignMasterName: Yup.string()
      .trim()
      .required(`${mixDesignMasterTypeName} is required field`),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MixDesignMasterIDEncrypted: "",
      MixDesignMasterType: mixDesignMasterType,
      MixDesignMasterName: "",
      Description: "",
      ExtraColumn1: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let payload = {
      MixDesignMasterIDEncrypted: values.MixDesignMasterIDEncrypted
        ? values.MixDesignMasterIDEncrypted
        : "",
      MixDesignMasterType: mixDesignMasterType,
      MixDesignMasterName: values.MixDesignMasterName.trim(),
      Description: values.Description.trim(),
      ExtraColumn1: values.ExtraColumn1.trim(),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(
      values.MixDesignMasterIDEncrypted
        ? POST_MixDesignMasterUpdate
        : POST_MixDesignMasterInsert,
      payload,
    )
      .then((response) => {
        if (response.IsSuccess) {
          successMessage(response?.Message);
          formik.resetForm();
          getData(1, currentSizePerPage);
          if (values.MixDesignMasterIDEncrypted) {
            setMixDesignMasterModal(false);
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function add_mixDesignMaster() {
    formik.resetForm();
    formik.setFieldValue("MixDesignMasterType", mixDesignMasterType);

    setMixDesignMasterModal(true);
  }

  const get_MixDesignMasterByID = async (ID, MixType) => {
    setIsLoading(true);
    await post(POST_GetMixDesignMasterByID, {
      MixDesignMasterIDEncrypted: ID,
      MixDesignMasterType: MixType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.resetForm();
          formik.setValues({
            MixDesignMasterIDEncrypted: ID,
            MixDesignMasterType: mixDesignMasterType,
            MixDesignMasterName: response.MixDesignMasterName,
            Description: response.Description,
            ExtraColumn1: response.ExtraColumn1,
          });
          setMixDesignMasterModal(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Mix Design Master</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 82 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 82 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="#"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => add_mixDesignMaster()}
                  >
                    <i className="fa-solid fa-plus"></i> Add{" "}
                    {mixDesignMasterTypeName}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <Row className="ps-1 me-0">
                <Col lg={2} className="p-1">
                  <div className="basic-list-group">
                    <ListGroup as="ul" style={{ borderRadius: "0" }}>
                      {mixDesignMasterTypeList?.map((list, i) => (
                        <Fragment key={i}>
                          <ListGroup.Item
                            as="li"
                            style={{
                              cursor: "pointer",
                              padding: "0.67rem 1rem",
                            }}
                            className={
                              list.MixDesignMasterType === mixDesignMasterType
                                ? "active"
                                : ""
                            }
                            onClick={() => {
                              setMixDesignMasterTypeName(list.Name);
                              setMixDesignMasterType(list.MixDesignMasterType);
                              formik.setFieldValue(
                                "MixDesignMasterType",
                                list.MixDesignMasterType,
                              );
                            }}
                          >
                            {list.Name}
                          </ListGroup.Item>
                        </Fragment>
                      ))}
                    </ListGroup>
                  </div>
                </Col>
                <Col lg={10} className="p-1">
                  {showFilter ? (
                    <div>
                      <FormikProvider value={formikFilter}>
                        <Form onSubmit={formikFilter.handleSubmit}>
                          <Row className="me-0">
                            <Col lg={3}>
                              <Field
                                label="Search"
                                name="Search"
                                placeholder={"Search here..."}
                                component={CustomInput}
                              />
                            </Col>
                            <Col lg={3}>
                              <Field
                                label="Status"
                                name="Status"
                                placeholder={"Select Status"}
                                options={statusOptions}
                                component={CustomSelect}
                                isClearable={false}
                              />
                            </Col>
                            <Col lg={3}>
                              <label className="mb-1">&nbsp;</label>
                              <div className="d-flex">
                                <div className="d-lg-block">
                                  <Link
                                    className="btn btn-primary btn-sm"
                                    onClick={(e) => {
                                      getData();
                                    }}
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Search
                                  </Link>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </FormikProvider>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    id="MixDesignMaster-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="MixDesignMaster-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="6%"></th>
                          <th
                            style={{
                              width: "30%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("MixDesignMasterName");
                            }}
                          >
                            {mixDesignMasterTypeName}{" "}
                            <span className="ml-1">
                              {sortBy == "MixDesignMasterName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>

                          <th
                            style={{
                              width: "45%",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            onClick={() => {
                              handleClickSorting("Description");
                            }}
                          >
                            {mixDesignMasterType == 8 ? "Title" : "Description"}{" "}
                            <span className="ml-1">
                              {sortBy == "Description" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          {mixDesignMasterType == 3 && (
                            <th
                              style={{
                                width: "45%",
                                cursor: "pointer",
                                textAlign: "left",
                              }}
                              onClick={() => {
                                handleClickSorting("ApproximateAirContent");
                              }}
                            >
                              Approximate Air Content
                              <span className="ml-1">
                                {sortBy == "ApproximateAirContent" ? (
                                  orderBy == "desc" ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {mixDesignMasterList?.length > 0 ? (
                          mixDesignMasterList?.map((item, indx) => (
                            <tr key={indx}>
                              <td>
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 82 && x?.IsEdit,
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    onClick={() =>
                                      get_MixDesignMasterByID(
                                        item.MixDesignMasterIDEncrypted,
                                        item.MixDesignMasterType,
                                      )
                                    }
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 82 && x?.IsActive,
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    className={`icon-box icon-box-md me-1`}
                                    title={
                                      item.IsActive == true
                                        ? "Active"
                                        : "Inactive"
                                    }
                                    onClick={() => {
                                      ActiveInactive_Record(
                                        item.IsActive,
                                        POST_MixDesignMasterStatusUpdate,
                                        {
                                          MixDesignMasterIDEncrypted:
                                            item.MixDesignMasterIDEncrypted,
                                          MixDesignMasterType:
                                            item.MixDesignMasterType,
                                          IsActive: !item.IsActive,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.MixDesignMasterName,
                                      );
                                    }}
                                  >
                                    <i
                                      className={`fa fa-circle fs-15 ${
                                        item.IsActive == true
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                    ></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 82 && x?.IsDelete,
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_Record(
                                        POST_MixDesignMasterDelete,
                                        {
                                          MixDesignMasterIDEncrypted:
                                            item.MixDesignMasterIDEncrypted,
                                          MixDesignMasterType:
                                            item.MixDesignMasterType,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.MixDesignMasterName,
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>{item.MixDesignMasterName}</td>

                              <td
                                style={{ textAlign: "left", cursor: "pointer" }}
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.Description}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.Description}</span>
                                </OverlayTrigger>
                              </td>
                              {mixDesignMasterType == 3 && (
                                <td style={{ textAlign: "left" }}>
                                  {item.ExtraColumn1}
                                </td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <CustomSizePerPage
                        getData={getData}
                        currentSizePerPage={currentSizePerPage}
                      />
                      <div className="dataTables_info">
                        Showing{" "}
                        {recordCount > 0
                          ? (currentPage - 1) * currentSizePerPage + 1
                          : 0}{" "}
                        to{" "}
                        {recordCount > currentPage * currentSizePerPage
                          ? currentPage * currentSizePerPage
                          : recordCount}{" "}
                        of {recordCount} entries
                      </div>
                      <CustomPaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        currentSizePerPage={currentSizePerPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Spin>
        <Modal
          //   size="lg"
          className="fade"
          show={mixDesignMasterModal}
          onHide={setMixDesignMasterModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{mixDesignMasterTypeName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setMixDesignMasterModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                          <Field
                            type="text"
                            label={mixDesignMasterTypeName}
                            name="MixDesignMasterName"
                            placeholder={`Enter ${mixDesignMasterTypeName}`}
                            component={CustomInput}
                            maxLength={250}
                            required
                            autoFocus
                            onChange={(e) => {
                              formik.setFieldValue(
                                "MixDesignMasterName",
                                capitalizeString(e?.target?.value),
                              );
                            }}
                          />
                        </Col>
                        {mixDesignMasterType == 3 && (
                          <Col lg={12}>
                            <Field
                              type="text"
                              label={"Approximate Air Content"}
                              name="ExtraColumn1"
                              placeholder={`Enter Approximate Air Content`}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>
                        )}
                        <Col lg={12}>
                          <Field
                            type="text"
                            label={`${
                              mixDesignMasterType == 8 ? "Title" : "Description"
                            }`}
                            name="Description"
                            placeholder={`${
                              mixDesignMasterType == 8
                                ? "Enter Title"
                                : "Enter Description"
                            }`}
                            component={CustomTextArea}
                            maxLength={500}
                            rows={5}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary btn-sm" type="submit">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setMixDesignMasterModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default MixDesignMaster;
